import React from 'react';

import { getShortDomainName } from '../../../utils/domain-utils';

const AddressInfo = () => {
  const domainName = getShortDomainName();

  if (domainName === 'pro') {
    return (
      <>
        <p className="tutorium-footer-license-text mt-25px">
          REINFORCEMENT LTD . REGISTERED UNDER THE INTERNATIONAL BUSINESS COMPANIES ACT | COMPANY NUMBER: 217470
        </p>
        <p className="tutorium-footer-license-text mt-10px">
          Registered Address: Suite 1, Second Floor, Sound & Vision House, Francis Rachel Str., Victoria, Mahe,
          Seychelles
        </p>
        <p className="tutorium-footer-license-text mt-10px">© 2019 Tutorium.{domainName}. All Rights Reserved. </p>
        <p className="tutorium-footer-license-text is-nowrap mt-10px">
          <a href="docs/pro/Terms of Use.pdf" target="_blank" className="tutorium-license-link">
            Terms of Use
          </a>
          {' | '}
          <a href="docs/pro/Privacy Notice.pdf" target="_blank" className="tutorium-license-link">
            Privacy Notice
          </a>
          {' | '}
          <a href="docs/pro/Refund Policy.pdf" target="_blank" className="tutorium-license-link">
            Refund Policy
          </a>
        </p>
      </>
    );
  }

  return (
    <>
      <p className="tutorium-footer-license-text mt-25px">
        VP TUTORIUM LTD | REGISTERED UNDER THE COMPANIES LAW, CAP. 113 | COMPANY NUMBER: HE402179
      </p>
      <p className="tutorium-footer-license-text mt-10px">
        Registered Address: Klimentos 41-43, KLIMENTOS TOWER, Flat/Office 25, 1061, Nicosia, Cyprus
      </p>
      <p className="tutorium-footer-license-text mt-10px">© 2019 Tutorium.{domainName}. All Rights Reserved. </p>
      <p className="tutorium-footer-license-text is-nowrap mt-10px">
        <a href="docs/vip/Terms of Use.pdf" target="_blank" className="tutorium-license-link">
          Terms of Use
        </a>
      </p>
    </>
  );

  // return (
  //   <>
  //     <p className="tutorium-footer-license-text mt-10px">
  //       © 2019 Tutorium.{domainName}. All Rights Reserved.{' '}
  //       {/* <a href="docs/pro/Terms of Use.pdf" target="_blank" className="tutorium-license-link">
  //           Terms of Use
  //         </a>
  //         {' | '}
  //         <a href="docs/pro/Privacy Notice.pdf" target="_blank" className="tutorium-license-link">
  //           Privacy Notice
  //         </a>
  //         {' | '}
  //         <a href="docs/pro/Refund Policy.pdf" target="_blank" className="tutorium-license-link">
  //           Refund Policy
  //         </a> */}
  //     </p>
  //   </>
  // );
};

export default AddressInfo;
